import React, { useEffect, useState } from 'react'
import SideBar from '../Sidebar/SideBar';
import { Icon } from '@iconify/react/dist/iconify.js';
import JoditEditor from 'jodit-react';
import RemarksApi from '../../Api/RemarksApi';
import Swal from "sweetalert2";

const SupportTemplate = () => {

    const [currentTemplateId, setCurrentTemplateId] = useState('');

    const [sendData, setSendData] = useState({
        TemplateType: '',
        Title: '',
        Description: ''
    });
    console.log("sendData", sendData);


    const [data, setData] = useState([]);


    const handleSave = async () => {

        const response = await RemarksApi.CreateRemarks(sendData)
        if (response.StatusCode === 201) {
            console.log("response", response);
            setSendData({
                TemplateType: '',
                Title: '',
                Description: ''
            })
            Swal.fire({
                title: "Info",
                text: "Created Successfully.",
                icon: "info",
                width: "320px"
            });
            fetchData()
        }
    }

    const handleUpdate = async () => {
        const resposne = await RemarksApi.UpdateRemarksById(currentTemplateId, sendData)
        if (resposne.StatusCode === 200) {
            console.log("response", resposne);
            setSendData({
                TemplateType: '',
                Title: '',
                Description: ''
            })
            setCurrentTemplateId('')
            fetchData()
        }

    }


    const handleEdit = (item) => {
        setCurrentTemplateId(item.id)
        setSendData({
            TemplateType: item.TemplateType,
            Title: item.Title,
            Description: item.Description
        })
        console.log(`Edit item with id ${item.id}`);
    };

    const handleDelete = async (id) => {
        const result = await Swal.fire({
            title: "Delete this template?",
            text: "This action cannot be undone.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete",
            cancelButtonText: "No, keep it",
            reverseButtons: true,
            width: "340px",
        });

        if (!result.isConfirmed) return;

        const response = await RemarksApi.DeleteRemarksById(id)
        if (response.StatusCode === 200) {
            console.log("response", response);
            Swal.fire({
                title: "Deleted",
                text: "Deleted Successfully.",
                icon: "success",
                width: "320px"
            });
            fetchData()
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target
        setSendData((prev) => {
            return {
                ...prev,
                [name]: value
            }
        })
    }

    const handleEditorChange = (newContent) => {
        setSendData((prev) => ({
            ...prev,
            Description: newContent,
        }));
    };


    const fetchData = async () => {
        const response = await RemarksApi.GetAllRemarks()
        if (response.StatusCode === 200) {
            console.log("response", response);
            setData(response.Result);

        }
    }

    useEffect(() => {
        fetchData();
    }, []);



    return (
        <div className='Flex-general-client-sidebar'>
            <div className='sidebar-gen-width'>
                <SideBar />
            </div>
            <div className='Main-general-Client'>
                <div className='header-general'>
                    <h2 className='general-card-title'>Support Template Master</h2>
                </div>
                <div className="control_radius">
                    {/* <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Name</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="" required />
                                    <label class="modify_p_text2">Mobile No</label>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="company_control">
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <select className="modify_im_input mode_category1"
                                        type="text" name="TemplateType" value={sendData.TemplateType} onChange={handleChange} required >

                                        <option value="">------Select------</option>
                                        <option value="IssueRemark">Issue Remark</option>
                                        <option value="Email">Email</option>
                                        <option value="Notification">Notification</option>
                                        <option value="Alert">Alert</option>
                                        <option value="Reminder">Reminder</option>
                                        <option value="Warning">Warning</option>
                                    </select>
                                    <label class="modify_lbl_text3">Template Type</label>
                                </div>
                            </div>
                        </div>
                        <div className="stock-im-dep1">
                            <div className="input-box-Imo1 input-height2">
                                <div className="input-box-mok1">
                                    <input className="modify_im_input mode_category1"
                                        type="text" name="Title" value={sendData.Title} onChange={handleChange} required />
                                    <label class="modify_p_text2">Title</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='table-account-manager'>
                        <JoditEditor onChange={handleEditorChange} value={sendData.Description} />
                    </div>
                    <div className="ButtonTabSave">

                        {
                            currentTemplateId ? (
                                <button
                                    id="SaveBtnMain"
                                    className={`update-button-main-save hovered`}
                                    onClick={handleUpdate}
                                >
                                    Update
                                </button>
                            ) : (
                                <button
                                    id="SaveBtnMain"
                                    className={`save-button-main-save hovered`}
                                    onClick={handleSave}
                                >
                                    Save
                                </button>
                            )
                        }
                    </div>
                </div>

                <div className="company_info-text-im depart_top">Support Template Master List</div>
                <div className="control_radius">
                    <div className="table-account-manager">
                        <table className='table-master-acc'>
                            <thead className='header-table-account'>
                                <tr>
                                    <th className='table-header-manager ac-sno-wth'>S.No</th>
                                    <th className='table-header-manager'>Template Type</th>
                                    <th className='table-header-manager'>Title</th>
                                    <th className='table-header-manager'>Description</th>
                                    <th className='table-header-manager'>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, idx) => (
                                    <tr key={item.id}>
                                        <td className='table-data-account ac-sno-wth'>{idx + 1}</td>
                                        <td className='table-data-account'>{item.TemplateType}</td>
                                        <td className='table-data-account'>{item.Title}</td>
                                        <td className='table-data-account'
                                            style={{
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                maxWidth: "500px",
                                            }}
                                        >{item.Description}</td>
                                        <td className='table-data-account'>
                                            <button className="edit-btn-acc" onClick={() => handleEdit(item)}><Icon icon="lucide:edit" /></button>
                                            <button className="delete-btn-acc" onClick={() => handleDelete(item.id)}><Icon icon="material-symbols:delete" /></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SupportTemplate;
